module.exports = __webpack_public_path__ + "media/widow.b2790352.mp4";